export interface IJsonDate {}

import { InvalidateDate } from "../Datepicker/Resources/ContentContent";
import { CommonHelper } from "../Helpers/CommonHelper";

export class JsonDateParser {
    public static toDate(value: IJsonDate): Date {
        if (!value || value +"" == InvalidateDate) {
            return null;
        }
        const dateString = this.getDate(value);
        const date = new Date(dateString);
        let offset = date.getTimezoneOffset();

        if(this.isDaylightSavingTime(date)){
            offset += 60;
        }

        return new Date(date.getTime() + 60000 * offset);
    }

    public static toDateNoOffset(value: IJsonDate): Date {
        if (!value) {
            return null;
        }
        const dateString = this.getDate(value);
        const date = new Date(dateString);
        return date;
    }

    public static isDaylightSavingTime(value: Date): boolean {
        //UK time 15/07/2023, 09:06:17
        let now = new Date();
        if(value){
            now = value
        }
        const UKTimeString = now.toLocaleString("en-GB", {timeZone : "Europe/London"}).split(' ');

        const mmddyyyy = UKTimeString[0].replace(',','').split("/")
        const hour = Number(UKTimeString[1].split(':')[0])

        const UkTime = new Date(Number(mmddyyyy[2]), Number(mmddyyyy[1]) - 1, Number(mmddyyyy[0]), hour)
        const UTCTime = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours())

        return UkTime.getTime() > UTCTime.getTime()
    }

    public static toJsonDateNoOffset(value: Date): IJsonDate {
        if (!value) {
            return null;
        }

        let offset = value.getTimezoneOffset();

        if(this.isDaylightSavingTime(value)){
            offset += 60;
        }

        const utcDate = new Date(value.getTime() - offset * 60000);

        const jsonDate = utcDate.toISOString();

        return jsonDate;
    }

    public static toJsonDate(value: Date): IJsonDate {
        if (!value) {
            return null;
        }

        let offset = 0;

        if(this.isDaylightSavingTime(value)){
            offset += 60;
        }

        const utcDate = new Date(value.getTime() + offset * 60000);

        const jsonDate = utcDate.toISOString();
        
        return jsonDate;
    }

    private static getDate(value: IJsonDate): string {
        return value.toString().charAt(value.toString().length - 1) === "Z" ||
            value
                .toString()
                .substr(value.toString().length - 6)
                .indexOf("+") >= 0
            ? value.toString()
            : value.toString() + "Z";
    }

    //format time for type "2018-08-07T10:43:44.38"
    public static formatDateReceived(time: string): Date {
        if (CommonHelper.isNullOrEmpty(time)) {
            return new Date();
        } else {
            if (time.indexOf(".") < 0) {
                time += ".00";
            }
            const reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])(T)(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d(.)\d*$/ as any;
            const regExp = new RegExp(reg);
            if (!regExp.test(time)) {
                alert("DateFormat error ,eg : '2018-08-07T10:43:44.38' ");
            } else {
                const subTime = time.substr(0, time.indexOf("."));
                const timeArry = subTime.split("T");

                const dateArry = timeArry[0].split("-");
                const dateTimeArry = timeArry[1].split(":");
                const year = Number(dateArry[0]);
                const month = Number(dateArry[1]) - 1;
                const day = Number(dateArry[2]);
                const hour = Number(dateTimeArry[0]);
                const minute = Number(dateTimeArry[1]);
                const second = Number(dateTimeArry[2]);

                return new Date(year, month, day, hour, minute, second);
            }
        }
    }

    public static getFormatDateString(
        date: Date,
        fmt: string,
        useMonthName?: boolean,
        useShortMonthName?: boolean
    ): string {
        if (date === null || date === undefined) {return ''}
        const o = {
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
            "q+": Math.floor((date.getMonth() + 3) / 3),
            "S+": date.getMilliseconds(),
            "M+": date.getMonth() + 1,
        };

        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }

        for (const k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                const str = RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length);
                if (k == "M+" && useMonthName) {                   
                    fmt = fmt.replace(RegExp.$1, this.getMonthNameMapping(str, useShortMonthName));
                }
                else
                {
                    fmt = fmt.replace(RegExp.$1, str);
                }  
            }
        }

        return fmt;
    }

    public static getFormatDate(dateStr: IJsonDate, format: string): string {
        if(!dateStr) {return null;}
        const date = new Date(dateStr + "");

        const o = {
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
            "q+": Math.floor((date.getMonth() + 3) / 3),
            S: date.getMilliseconds(),
        };

        if (/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }

        for (const k in o) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(
                    RegExp.$1,
                    RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
                );
            }
        }

        return format;
    }

    public static getMonthNameMapping(monthNumber: string | number, useShortName?: boolean): string {
        const monthNum = Number(monthNumber);
        const fullNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        const shortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const months = useShortName == true ? shortNames : fullNames;
        if (monthNum <= 0) {
            return months[0];
        } else if (monthNum >= 12) {
            return months[11];
        } else {
            return months[monthNum - 1];
        }
    }

    public static isValidDate(dateStr: IJsonDate): boolean {
        if(!dateStr) {return false;}
        const date = new Date(dateStr + "");
        return date.getFullYear() != 1;
    }

    public static calculateAge(dateOfBirth: IJsonDate): number {
        const today = new Date();
        const birthDate = this.toDate(dateOfBirth);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
        {
            age--;
        }
        return age;
    }

    public static isToday(jsonDateStr: IJsonDate): boolean {
        if(!jsonDateStr) {return false;}

        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const dateStr = jsonDateStr.toString();
        const todayStr = this.toJsonDateNoOffset(today).toString();
        return dateStr.substring(0, dateStr.indexOf("T")) === todayStr.substring(0, todayStr.indexOf("T"));
    }
}
